import type { ADDoc } from '@atlaskit/editor-common/utils/validator';

import { expValEquals } from '@confluence/feature-experiments';

export const parseMacroOutputAdf = (macroOutput: string): ADDoc | undefined => {
	try {
		if (macroOutput) {
			const parsed = JSON.parse(macroOutput);
			if (parsed.version === 1 && parsed.type === 'doc' && parsed.content) {
				return parsed as ADDoc;
			}
		}
	} catch (e) {
		// do nothing in case of parsing error, which would return `undefined`
	}
};

export const getMacroId = (node: any): any =>
	// The localId fallback is only needed for included-content TOC heading
	// links. Gate it so non-TOC excerpt rendering (including SSR placeholder
	// matching via data-fabric-macro / data-ssr-placeholder) keeps prior
	// behaviour and the macroId is unchanged.
	expValEquals('confluence_toc_included_content_exp', 'isEnabled', true)
		? node?.parameters?.macroMetadata?.macroId?.value ||
			node?.attrs?.parameters?.macroMetadata?.macroId?.value ||
			node?.localId ||
			node?.attrs?.localId
		: node?.parameters?.macroMetadata?.macroId?.value;
export const getMacroParam = (node: any, name: string): any =>
	node?.parameters?.macroParams?.[name]?.value;
